

























































































































import { Component, Vue } from "vue-property-decorator";
import ToolBar from "@/components/ToolBar.vue";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";
import app from "@/store/app";
import reward from "@/store/reward";

import { trimText, formatTextToNumber } from "@/utils/format";

@Component({
  components: { ToolBar, DatePicker }
})
export default class RewardDetails extends Vue {
  public listItemStyle(index: number) {
    return index % 2 !== 0 && { background: "#ececec" };
  }

  public startDate = moment()
    .subtract(7, "days")
    .format("YYYY-MM-DD");
  public endDate = moment().format("YYYY-MM-DD");

  get title() {
    return "收益詳情";
  }

  get rewardActivityData() {
    return reward.activityData;
  }

  public formatText(text: string) {
    return trimText(text);
  }

  public updateStartDate(date: string) {
    this.startDate = date;
  }

  public updateEndDate(date: string) {
    this.endDate = date;
  }

  public async mounted() {
    this.getData();
  }

  public async getData() {
    try {
      app.SET_IS_LOADING(true);
      const payload = {
        startdate: this.startDate,
        enddate: this.endDate
      };
      await reward.getRewardActivityData(payload);
      app.SET_IS_LOADING(false);
    } catch (error) {
      if (error.response.status === 401) {
        window.alert("因帳號權限原因，你目前無法查看此頁面內容");
      }
    }
  }

  public formatTextToNumber(text: string) {
    return formatTextToNumber(text);
  }
}
